import { render, staticRenderFns } from "./whatsAppTemplatesAdd.vue?vue&type=template&id=0a77fbbd&"
import script from "./whatsAppTemplatesAdd.vue?vue&type=script&lang=ts&"
export * from "./whatsAppTemplatesAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports